import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import logo from '../../img/logo.svg';
import menu from '../../img/menu.svg';
import Arrow from '../../img/Arrow.svg';
import NavigationStyle from './navigationStyle';
import navImg from '../../img/navImg.svg';
import close from '../../img/close.svg';

import normal from '../../files/nishant arora resume.pdf'
import EuroPass from '../../files/CV-Europass-20200222-Arora-EN.pdf'

class Navigation extends Component {
    constructor(props){
        super(props);
        // const cursor = document.querySelector('.cursor');

        // document.addEventListener('mousemove', e => {
        //     cursor.setAttribute("style", "top: "+(e.pageY - 10)+"px; left: "+(e.pageX - 10)+"px;")
        // });

        // function mouseoverFunc(){
        //     cursor.classList.add("expand");
        // }

        // function mouseoutFunc(){
        //     cursor.classList.remove("expand");
        // }
        this.state = {
            data: [],
            blured: '',
        };
    }

    componentDidMount() {
        this.setState({
            data: [
                { id: "1", title: "Work I did till now", sub: "Projects"},
                { id: "2", title: "Say Hi!", sub: "Contacts"}
            ]
        });
    }

    blur() {
        this.setState({
            blured: true
        })
    };
    blurOut() {
        this.setState({
            blured: false
        })
    };


    render() {
        return (
            <React.Fragment>
                <header className="container">
                    <Link to="/">
                        <img src={logo} alt="logo" className="nav-logo"/>
                    </Link>
                    <img onClick={this.props.open} src={menu} alt="menu" className="menu-icon"/>
                </header>
                <div id="sideNav" className="navbar-drawer">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="row leftNav">
                                <div className="leftNavWrap">
                                        <img src={close} className="closeImg d-block d-md-block d-lg-none d-xl-none" onClick={this.props.close} alt="close Icon"/>
                                        {this.state.data.map((post, i) => {
                                            return (
                                                <Link to={`/${post.sub}`} onClick={this.props.close}>
                                                    <div
                                                        className="navDrawer-row col-lg-12"
                                                        style={this.state.blured ? {filter: 'blur(6px)',transition: 'all 1s ease-in-out'} : {filter: 'blur(0px)',transition: 'all 1s ease-in-out'}}
                                                        onMouseOver={() => this.blur()}
                                                        onMouseLeave={() => this.blurOut()}
                                                        key={i}
                                                     >
                                                        <p><img src={Arrow} alt="arrow" /> {post.title}</p>
                                                        <span>{post.sub}</span>
                                                    </div>
                                                </Link>
                                            )
                                        })}
                                        <a href={normal} download  className="btn DownloadBtn ml-3 mr-3 mt-5">Download CV</a>
                                        <a href={EuroPass} download  className="btn DownloadBtn mt-5">Download Europass CV</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 rightNav d-none d-md-none d-lg-block d-xl-block">
                            <img className="BannerImg" src={navImg} alt='BannerImg'/>
                            <img src={close} className="closeImg" onClick={this.props.close} alt="close Icon"/>
                        </div>
                    </div>
                </div>
                {/* <div className="cursor"></div> */}
                <NavigationStyle/>
            </React.Fragment>
        );
    }
}

export default Navigation;
